import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { Container, Typography, Box, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { getPostBySlug } from '../utils/blog';
import MarkdownContent from '../components/MarkdownContent';
import TagChip from '../components/Blog/TagChip';

const useStyles = makeStyles((theme) => ({
  backLink: {
    marginBottom: theme.spacing(3),
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  date: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  tags: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(4),
  },
}));

const BlogPostPage = () => {
  const classes = useStyles();
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  if (!post) {
    return (
      <Container maxWidth="md">
        <Box sx={{ py: 6 }}>
          <Typography variant="h4" gutterBottom>
            Post not found
          </Typography>
          <Button component={Link} to="/blog" startIcon={<ArrowBack />}>
            Back to blog
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="md">
      <Box sx={{ py: 6 }}>
        <Button
          component={Link}
          to="/blog"
          startIcon={<ArrowBack />}
          className={classes.backLink}
        >
          Back to blog
        </Button>

        <Typography variant="h2" className={classes.title}>
          {post.title}
        </Typography>

        <Typography variant="body2" className={classes.date}>
          {new Date(post.date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
        </Typography>

        <Box className={classes.tags}>
          {post.tags &&
            post.tags.map((tag) => <TagChip key={tag} tag={tag} />)}
        </Box>

        <MarkdownContent body={post.body} />
      </Box>
    </Container>
  );
};

export default BlogPostPage;
